// Copyright (c) 2017 Deere & Company

import {
    createAuditSummaryReport,
    resetAuditSummaryReport
} from './report';
import {
    resetAuditResultModal,
    updateAuditResultModal
} from './audit-result-modal';
import {
    resetAuditSummaryCriteria,
    selectAllTerritories,
    selectAuditSummaryCriteria,
    updateAuditSummaryTerritory
} from './criteria';
import {readTerritories} from './read-territories';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    ...sharedActionCreators,
    createAuditSummaryReport,
    readTerritories,
    resetAuditResultModal,
    resetAuditSummaryCriteria,
    resetAuditSummaryReport,
    selectAllTerritories,
    selectAuditSummaryCriteria,
    updateAuditResultModal,
    updateAuditSummaryTerritory
};



// WEBPACK FOOTER //
// ./src/reports/audit-summary/action-creators/index.js